module.exports = {
	"articleTitle1": "Blimpy Burger re-opens after a year of closing",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Blimpy Burger",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/blimpy-burger-closes",
	"articleSnippet1": "Oct 3, 2014 ... Rich Magner, the owner of Blimpy Burger, was in the kitchen. He opened the \nfridge to check on the hamburger meat, which he and his ...",
	"articleSnippet2": "Aug 14, 2013 ... Over the past several days, lines at Blimpy Burger have been as long as three \nhours as customers have waited to have one final burger before ...",
	"foodRecommendations": [
		{
			"text": "Forego french fries and get the fried vegetables instead!!",
			"person": "Amelia Cacchione"
		}
	],
	"articleTitle2": "Blimpy Burger",
	"address": "304 S Ashley St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279394,
		"lng": -83.750129
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/blimpyburger.json
// module id = 831
// module chunks = 0